import styled from "@emotion/styled";
import Monogram from "src/components/Monogram";
import {
  PRIMARY_BLACK,
  BACKGROUND_LIGHT,
  TERTIARY_GREY,
} from "src/constants/colors";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 32px;
`;

const DisplayName = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 20px;
  font-weight: 500;
  margin: 0;
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
`;

const ApplicationIdContainer = styled.div`
  background-color: ${BACKGROUND_LIGHT};
  border-radius: 10px;
  color: ${TERTIARY_GREY};
  display: flex;
  align-items: center;
  font-size: 11px;
  padding: 5px;
`;

interface HeaderProps {
  name: string;
  applicationId: string;
}

export default ({ name, applicationId }: HeaderProps) => (
  <Container>
    <NameContainer>
      <Monogram size={52}>{name?.charAt(0)}</Monogram>
      <DisplayName>{name}</DisplayName>
    </NameContainer>
    <ApplicationIdContainer>{applicationId}</ApplicationIdContainer>
  </Container>
);
